import React, { useState } from 'react';
import { ArrowUpRightIcon, CheckIcon, CopyIcon } from 'lucide-react';
import { profile } from '../data/profile';
import { Reveal } from '../components/Reveal';
import { SectionHeading } from '../components/SectionHeading';
export function Contact() {
  const [copied, setCopied] = useState(false);
  const [copyError, setCopyError] = useState(false);
  const copyEmail = async () => {
    try {
      await navigator.clipboard.writeText(profile.email);
      setCopied(true);
      setCopyError(false);
      window.setTimeout(() => setCopied(false), 2000);
    } catch {
      setCopyError(true);
    }
  };
  const rowClass = 'flex flex-wrap items-center justify-between gap-4 border-b border-line-dark py-7';
  return <section aria-labelledby="contact-title" className="bg-ink py-20 md:py-28" data-id="element-169" data-mp="12yh7fmnuqeqz">
      <div className="mx-auto grid max-w-7xl gap-14 px-6 lg:grid-cols-12 lg:px-10" data-id="element-170" data-mp="f8wmiy8517f2">
        <div className="lg:col-span-5" data-id="element-171" data-mp="aa1v57w3uajc">
          <SectionHeading id="contact-title" tone="dark" label="10 · Professional engagement" title="Get in touch." intro="For employers, recruiters, executive search consultants, clients and professional contacts. Direct enquiries are welcome." data-id="element-172" data-mp="a90k33f39o1m" />
        </div>

        <Reveal delay={0.05} className="lg:col-span-7 lg:pt-14" data-id="element-173" data-mp="1j6k6r7l7nhl7">
          <ul className="border-t border-line-dark" data-id="element-174" data-mp="1j8y09c08slqn">
            <li className={rowClass} data-id="element-175" data-mp="mhcms408pgje">
              <div className="min-w-0" data-id="element-176" data-mp="midvi1ts9qxy">
                <p className="text-sm text-slate-light" data-id="element-177" data-mp="qhwkp9sn0o6l">Email</p>
                <a href={`mailto:${profile.email}`} className="mt-1 block break-all font-serif text-2xl text-paper underline decoration-line-dark underline-offset-8 transition-colors duration-150 hover:decoration-bronze-light md:text-3xl" data-id="element-178" data-mp="qk8xl8jjg8cs">
                  {profile.email}
                </a>
              </div>
              <button type="button" onClick={copyEmail} className="inline-flex items-center gap-2 rounded-sm border border-line-dark px-4 py-2.5 text-sm text-paper transition-colors duration-150 hover:border-slate-light focus:outline-none focus-visible:ring-2 focus-visible:ring-bronze-light" data-id="element-179" data-mp="2bu7ngbjd1o2k">
                {copied ? <CheckIcon className="h-4 w-4" aria-hidden="true" data-id="element-180" data-mp="1r5wzzkwqh3bf" /> : <CopyIcon className="h-4 w-4" aria-hidden="true" data-id="element-181" data-mp="1r780nbuvtuyb" />}
                <span aria-live="polite" data-id="element-182" data-mp="13hx8girll8vs">{copied ? 'Copied' : copyError ? 'Copy unavailable' : 'Copy'}</span>
              </button>
            </li>
            <li className={rowClass} data-id="element-183" data-mp="yfy4b6o1a7xs">
              <div data-id="element-184" data-mp="1d6xakb1ecke7">
                <p className="text-sm text-slate-light" data-id="element-185" data-mp="1d7gsvsuylasr">LinkedIn</p>
                <a href={profile.linkedinHref} target="_blank" rel="noreferrer noopener" className="mt-1 inline-flex items-center gap-2 font-serif text-2xl text-paper transition-colors duration-150 hover:text-bronze-light" data-id="element-186" data-mp="18ff81ijq6br4">
                  {profile.linkedin}
                  <ArrowUpRightIcon className="h-5 w-5" aria-hidden="true" data-id="element-187" data-mp="2rdbvo5bxyz2f" />
                </a>
              </div>
            </li>
            <li className={rowClass} data-id="element-188" data-mp="2hggufeoaakkg">
              <div data-id="element-189" data-mp="2hhici33pw7bo">
                <p className="text-sm text-slate-light" data-id="element-190" data-mp="2hia658dr7uzb">Phone</p>
                <a href={profile.phoneHref} className="mt-1 block font-serif text-2xl tabular-nums text-paper transition-colors duration-150 hover:text-bronze-light" data-id="element-191" data-mp="2mes9q4xclna2">
                  {profile.phone}
                </a>
              </div>
            </li>
            <li className={rowClass} data-id="element-192" data-mp="3f1v4clywldv1">
              <div data-id="element-193" data-mp="3157u5hhxwr76">
                <p className="text-sm text-slate-light" data-id="element-194" data-mp="313odvqwaag5e">Based in</p>
                <p className="mt-1 font-serif text-2xl text-paper" data-id="element-195" data-mp="355i9hkrmgtyp">{profile.location}</p>
              </div>
            </li>
          </ul>
        </Reveal>
      </div>
    </section>;
}